<template>
  <div class="bind-opencard-dialog">
    <custom-dialog width="1000px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <span v-if="asyncTime">{{ $t('dms_bindOpencardDialog.zhscsj') }}：{{ momentAmPm($momentLocal(asyncTime)) }}</span>
          </el-form-item>
          <el-form-item style="float: right; margin-right: 0">
            <el-button type="primary" @click="onCardDialog()">
              <i class="icon icon-add"></i>
              {{ $t('dms_bindOpencardDialog.tian_jia_kai_ji_ka') }}
            </el-button>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button type="primary" @click="onRefreshCard()" :disabled="asyncing">
              <i class="icon icon-shuaxin"></i>
              {{ $t('dms_bindOpencardDialog.tbzxxx') }}
              <span v-if="asyncing">（{{ $t('dms_bindOpencardDialog.shua_xin_zhong') }}... ）</span>
            </el-button>
          </el-form-item>
        </el-form>
        <custom-table :index="true" :data="tableList" tableCode="bindCard" @filter="filterChange" @sort="sortChange" :row-class-name="rowClassName">
          <template slot="action" slot-scope="scope" v-if="![1, 2, 3].includes(scope.row.cardSlot)">
            <el-button type="text" size="mini" @click="deleteCard(scope.row)">{{ $t('Common.com_delete') }}</el-button>
          </template>
        </custom-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
    <opencard-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSelectCard"></opencard-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import opencardDialog from '@/pages/dms/components/opencardDialog.vue';

export default {
  mixins: [dialogMixins],
  components: {
    opencardDialog,
  },
  data() {
    return {
      tableSelect: [],
      reduceList: [],
      tableList1: [],
      dialogVisible: false,
      dialogModel: {},
      asyncing: false,
      asyncTime: '',
      disableConfirm: false
    };
  },
  mounted() {
    this.bindCardList();
  },
  computed: {
    tableList: vm => [...vm.tableSelect, ...vm.tableList1],
  },
  methods: {
    rowClassName: function ({ row }) {
      return row.isNew ? 'is-new' : '';
    },
    // 关联开机卡列表
    bindCardList: function () {
      this.$getJSON(apis.bootCardBindList, {
        deviceId: this.model.row.deviceId,
      }).then((res) => {
        this.tableList1 = res.data.cardList;
        this.asyncTime = res.data.uploadTime;
      });
    },
    // 刷新开机卡
    onRefreshCard: function () {
      this.$postJSON(`${apis.bootCardAssociateDeviceRefresh}/${this.model.row.deviceId}`).then(() => {
        this.asyncing = true;
        setTimeout(() => {
          this.asyncing = false;
          this.bindCardList();
        }, 8000);
      });
    },
    // 删除关联卡
    deleteCard: function (row) {
      if (row.isNew) {
        // this.tableSelect = this.tableSelect.filter(t => t.cardId !== row.cardId);
        this.tableSelect = this.tableSelect.filter(t => t.cardSlot !== row.cardSlot);
      } else {
        this.reduceList.push(row);
        // this.tableList1 = this.tableList1.filter(t => t.cardId !== row.cardId);
        this.tableList1 = this.tableList1.filter(t => t.cardSlot !== row.cardSlot);
      }
    },
    // 选择关联卡
    onSelectCard: function (list) {
      list.forEach((item) => {
        item.isNew = true;
      });
      this.tableSelect = [...this.tableSelect, ...list];
      this.dialogVisible = false;
    },
    // 选择关联卡
    onCardDialog: function () {
      this.dialogModel = { title: this.$t('dms_bindOpencardDialog.xuan_ze_kai_ji_ka'), row: this.tableSelect, deviceId: this.model.row.deviceId };
      this.dialogVisible = true;
    },
    // 确认保存
    confirm: function () {
      if (!this.tableSelect.length && !this.reduceList.length) {
        this.visible = false;
        return;
      }
      if (this.tableList.length > 13) {
        this.$message.error(this.$t('dms_bindOpencardDialog.mgsbzdzngl13zkjk'));
        return;
      }
      // 可填编号
      const cardSlots = [];
      for (var i = 4; i <= 13; i++) {
        // eslint-disable-next-line no-loop-func
        const has = this.tableList1.find(t => t.cardSlot === i);
        if (!has) {
          cardSlots.push(i);
        }
      }
      let cardList = [];
      if (this.tableSelect.length) {
        cardList = this.tableSelect.map((t, idx) => ({ cardId: t.cardId, cardSlot: cardSlots[idx] }));
      }
      if (this.reduceList.length) {
        this.reduceList.forEach((item) => {
          const slotHasAdd = cardList.find(t => t.cardSlot === item.cardSlot);
          if (!slotHasAdd) {
            cardList.push({ cardSlot: item.cardSlot });
          }
        });
      }
      if (this.disableConfirm) {
        return;
      }
      this.disableConfirm = true;
      this.$postJSON(apis.bootCardBind, {
        cardList: cardList,
        deviceId: this.model.row.deviceId,
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.disableConfirm = false;
        this.visible = false;
        // if (!res.data) {
        //   this.$postJSON(`${apis.bootCardAssociateDeviceRefresh}/${this.model.row.deviceId}`);
        // }
        this.$emit('success');
      }).catch(() => {
        this.disableConfirm = false;
      });
    },
  },
};
</script>

<style lang="scss">
.bind-opencard-dialog {
  .is-new td div {
    color: #c1c1c1;
  }
}
</style>
